<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"    
      bottom
      fixed 
      temporary     
    >
      <v-list-item>        
        <v-list-item-content>
          <v-list-item-title>Filters</v-list-item-title>
        </v-list-item-content>

      </v-list-item>


      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="(filter,index) in filters"
          v-if="filter.field_type != 'hidden' && filter.field_type != 'input'"
          :key="filter.id"
        >
          <v-list-item-content>
            <v-list-item-title              
            >
              <v-select               
                :items="filter.value"
                :label="filter.name"          
                v-model="selectedFilters[index]"                
                solo
              >
                
              </v-select>  
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-navigation-drawer
      v-model="langDrawer"    
      bottom
      fixed 
      temporary
    >
      <v-list-item>
          <v-list-item-content>
            <v-list-item-title              
            > Languages
            </v-list-item-title>
              <v-select 
                  label="Select your language"
                  :items="availableLangs"                       
                  v-model="language"
                  class="mt-2 ml-2"
                  solo
                ></v-select>
          </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
    
    <v-navigation-drawer
          v-model="settingsDrawer"    
          bottom
          fixed 
          height="250"
          temporary

        >
      <v-list-item>    
        <v-list-item-content>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title              
            > 
            </v-list-item-title>
              <v-slider
                  v-model="fontSize"
                  :label="fontSizeObject.label"
                  :thumb-color="fontSizeObject.color"
                  
                ></v-slider>
          </v-list-item-content>
        </v-list-item>        
      </v-list>
    </v-navigation-drawer>


    <v-app-bar
      app
      dense
    >      
      <v-toolbar-title>
        <v-btn
        :color="isConnected ? 'blue-gray' : 'error'"
        elevation="2"        
        dark
        @click.stop="dialogs.connect = true"
        >
          {{isConnected ? channel : 'START'}}
        </v-btn>
      </v-toolbar-title>
<!--       <v-toolbar-title v-if="channel !='ep'">
      
      </v-toolbar-title> -->

      <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="drawer = !drawer"
        v-if="isConnected && filters.length > 0"
        >
          Filters
      </v-btn>
      
      <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="langDrawer = !langDrawer"
        v-if="isConnected && channel.toLowerCase() != 'ep'"
        >
          Languages
      </v-btn>

      <v-dialog  v-model="dialogs.connect" persistent max-width="290">      
        <v-card>
          <v-card-title class="headline">Setup</v-card-title> 
          <v-card-text>
            <v-form v-model="valid" v-on:submit.prevent="start">
              <v-text-field
                v-model="channel"                
                label="Channel to connect"
                :rules="channelRules"
                required                      
              ></v-text-field>
              <span color="error" v-if="apiError.error">{{apiError.msg}}</span>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogs.connect = false ">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="start" :disabled="!valid">Connect</v-btn>
            <v-spacer></v-spacer>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>
     <v-btn
        color="blue-gray"        
        elevation="2"        
        dark
        @click.stop="settingsDrawer = !settingsDrawer"        
        >
          Settings
      </v-btn>
    </v-app-bar>

    <v-main 
     v-if="isConnected" 
     :style = "fontStyle"
    >  
      <actions 
       :medias="medias" 
       :action="action"
       :language="language"       
      ></actions>
    </v-main>

  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import * as Mqtt from 'mqtt'
import * as kalliope from './tools/kalliope.js'
import Languages from './tools/LanguageCodes.js'
import Actions from './components/Actions.vue'

export default {
  name: 'App',

  components: {
    Actions
  },

  data: () => ({
    dialogs: {
      connect: false,
      settings: false
    },
    drawer: false,
    settingsDrawer: false,
    langDrawer: false,
    valid: false,
    channelRules: [
      v => !!v || 'Name is required',
    ],
    channel: '',
    filters:[],
    medias:[],
    selectedFilters:[],
    apiError: {
      error: false,
      msg: ''
    },
    client: null,
    action: {},
    allowedActionTypes:['text','video','audio','image']
    
  }),
  mounted(){
    this.channel = 'kaweb'
    this.start()
    console.log(this)
  },
  methods:{
    async start(){
      let response = await kalliope.createPublicUser()
      let uuid = ''
      if (response == false){        
        this.setError("Error creating the public user")
      }else{
        uuid = this.getUUID(response)
        response = await kalliope.subscribeToChannel(this.getUUID(response),this.channel)
        if (response == false){          
          this.setError("This channel does not exist")          
        }
        else{
          this.filters = this.getFilters(response)
          this.filters.forEach((f) => this.selectedFilters.push(''))
          // console.log(this.filters)          
          this.mqttConnect(this.getTopic(response))

          response = await kalliope.getMedias(uuid,this.channel)
          if (response == false){
            console.log("Error getting Medias")
          }else{
            this.medias = this.getMedias(response)
          }
        }
        
      }
    },
    mqttConnect(topic){
      console.log(topic)
      // this.client = Mqtt.connect(this.mqttServer,{keepalive:5,rejectUnauthorized: false})
      this.client = Mqtt.connect(this.mqttServer,{keepalive:5})
      this.client.on('connect',() =>{
        console.log("MQTT connected")
          this.client.subscribe(topic, (err) => {
            if (!err) {
              console.log("Subscription OK")
              this.dialogs.connect = false
              this.$store.dispatch('setConnected')
            }else{              
              console.log("Subscription error",error)
            }
          })
      })
      this.client.on('end',this.onEnd)
      this.client.on('close',this.onClose)
      this.client.on('reconnect',this.onReconnect)
      this.client.on('message',this.onMessage)
      this.client.on('error',this.onMqttError)
    },
    onMessage(topic,message){
      let action = kalliope.parsePayload(JSON.parse(message.toString()).action)
      if (this.allowedActionTypes.includes(action.type))
        if (this.isForMe(action)){          
          this.action = action
          if (action.vibration)
            window.navigator.vibrate(800)
        }
        
      //console.log(topic,message)
    },
    onEnd(){
      console.log("MQTT Connection End")
      this.$store.dispatch('setDisconnected')
    },
    onClose(){
      console.log("MQTT Connection Close")
      this.$store.dispatch('setDisconnected')
    },
    onReconnect(){

    },
    onMqttError(error){
      console.log("MQTT Connection Error: ",error)
    },
    getUUID(response){
      return response.data.fields.uuid
    },
    getTopic(response){
      return response.data.fields.messagesScopeUrl + '/smartphone'
    },
    getMedias(response){
      return response.data.fields
    },
    getFilters(response){
      return response.data.fields.FormFields
    },
    setError(message){
      this.apiError.error = true
      this.apiError.msg = message
    },
    isForMe(action){
      let out = false
      if (action.filters == null)
        return true

      action.filters.forEach((filter) =>{
        this.filterIdsValueSelected.forEach((idValue) => {          
          if (filter.field_id == idValue.id && filter.value[0] == idValue.value)
            out = true
        })
      })
      console.log("isForMe result",out)
      return out
      //console.log(action,this.filterIdsSelected)
    },
  },
  computed:{
    localComputed(){

    },
    filterIdsValueSelected(){
      let tmp = []
      for (let i = 0; i < this.filters.length; i++){
        if (this.selectedFilters[i] != '')
          tmp.push({
            id: this.filters[i].id, 
            value: this.selectedFilters[i]
          })
      }
      return tmp
    },
    availableLangs(){
      return Languages.map((lang) =>{
        return{
          text: lang.name,
          value: lang.code  
        }
        

      })
    },
    fontStyle(){
      return {
        fontSize: this.fontSize + 'px'
      }
    },
    fontSizeObject(){
      return { 
          label: 'font size', 
          color: 'red' 
        }
    },
    language: {
        get(){
          this.$store.state.language
        },
        set(value){
          this.$store.dispatch('setLanguage',value)
        }
      },
    fontSize:{
      get(){        
        return this.$store.state.fontSize
      },
      set(value){
        this.$store.dispatch('setFontSize',value)
      }
    },
    ...mapState({
      mqttServer: state => state.mqttServer,
      isConnected: state => state.connected

    })
  }
};
</script>
<style>
html{
 /* overflow-y: hidden !important;*/
}
</style>
